var typedObjectKeys = Object.keys;

export { typedObjectKeys };
//# sourceMappingURL=typed-object-keys.js.map
